// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"acf080d54114e43cc051","777":"478c86d3cffe78ce3018"}[chunkId] + ".js";
};